import { memo } from 'react';

import { Breadcrumbs, type BreadcrumbsItemType } from '@air/component-breadcrumbs';

const COMPACT_BREADCRUMBS_THRESHOLD = 4;

export type AssetModalBreadcrumbsProps = {
  breadcrumbItems: BreadcrumbsItemType[];
};

export const AssetModalBreadcrumbs = memo(({ breadcrumbItems }: AssetModalBreadcrumbsProps) => (
  <div className="flex items-center ads:text-secondary text-gray-11" data-testid="BREADCRUMBS_CONTAINER">
    <Breadcrumbs
      className="truncate ads:text-secondary text-gray-11"
      isCompact={breadcrumbItems.length > COMPACT_BREADCRUMBS_THRESHOLD}
      visibleItemsAtEnd={1}
      size="small"
      items={breadcrumbItems}
    />
  </div>
));

AssetModalBreadcrumbs.displayName = 'AssetModalBreadcrumbs';
